export default __webpack_public_path__ + "static/media/GINTonic.f964c4dc.jpg";